import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function AnalisiPrezziPage() {
  return <ArticleLayout data={allArticles['analisi-prezzi']} />;
}